import { render, staticRenderFns } from "./poll-results.vue?vue&type=template&id=b80d1a8c&"
import script from "./poll-results.vue?vue&type=script&lang=js&"
export * from "./poll-results.vue?vue&type=script&lang=js&"
import style0 from "./poll-results.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "poll-results.vue"
export default component.exports